import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaDownload, FaFileAlt } from 'react-icons/fa';

const ProductsPage = () => {
  const { t } = useTranslation();

  // Bu şimdilik örnek bir PDF linki. Gerçek katalog PDF'i için değiştirilmeli.
  const pdfCatalogUrl = "/catalog.pdf"; // İleride gerçek katalog eklendiğinde bu link güncellenecek

  return (
    <>
      {/* Hero Section */}
      <section className="bg-primary text-white py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">{t('products.hero.title')}</h1>
          <p className="text-xl max-w-3xl">
            {t('products.hero.subtitle')}
          </p>
        </div>
      </section>

      {/* PDF Katalog Bölümü */}
      <section className="py-16 bg-dark-medium">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto bg-dark-light rounded-lg shadow-lg overflow-hidden">
            <div className="p-8 text-center">
              <FaFileAlt className="text-6xl text-white mx-auto mb-4" />
              <h2 className="text-3xl font-bold mb-4 text-white">{t('products.catalog.title') || "Ürün Kataloğumuz"}</h2>
              <p className="text-gray-300 mb-8">
                {t('products.catalog.description') || "Ürünlerimiz hakkında detaylı bilgi için aşağıdaki katalog dosyasını inceleyebilirsiniz."}
              </p>
              
              {/* PDF Görüntüleyici */}
              <div className="mb-8">
                <div className="border-4 border-dark-medium rounded-lg overflow-hidden">
                  <iframe 
                    className="w-full h-screen mx-auto" 
                    style={{ minHeight: '700px' }}
                    title="product-catalog"
                    src={pdfCatalogUrl}
                  >
                    {t('products.catalog.loading') || "PDF yükleniyor..."}
                  </iframe>
                </div>
              </div>
              
              {/* İndirme Butonu */}
              <div className="flex justify-center">
                <a 
                  href={pdfCatalogUrl} 
                  download
                  className="flex items-center gap-2 bg-primary hover:bg-blue-700 text-white px-6 py-4 rounded-md transition-colors duration-300"
                >
                  <FaDownload />
                  {t('products.catalog.download') || "Kataloğu İndir"}
                </a>
              </div>
            </div>
          </div>
          
          <div className="mt-12 text-center">
            <p className="text-gray-300">
              {t('products.catalog.contactInfo') || "Daha fazla bilgi almak için lütfen bizimle iletişime geçin."}
            </p>
            <a 
              href="/contact" 
              className="inline-block mt-4 text-primary hover:underline"
            >
              {t('products.catalog.contactLink') || "İletişim Sayfası"}
            </a>
          </div>
        </div>
      </section>
      
    </>
  );
};

export default ProductsPage;
